import { useEffect } from "react";
import AppHeader from "@/components/AppHeader";
import MotionAlerts from "@/components/MotionAlerts";
import MobileBottomNav from "@/components/MobileBottomNav";

/**
 * Full-screen motion alerts feed for mobile (accessed via bottom tab).
 * Reuses the MotionAlerts widget but in a dedicated route so mobile users
 * don't need to open the sidebar drawer.
 * On mount, marks alerts as read (updates localStorage lastViewedAt) so the
 * bottom-nav badge clears — matches Instagram/Twitter DMs behaviour.
 */
export default function MobileAlertsPage() {
  useEffect(() => {
    const now = Date.now().toString();
    localStorage.setItem("cctv_alerts_last_viewed_at", now);
    // Fire a storage event manually so same-tab listeners (e.g., MobileBottomNav)
    // also see the clear. The native storage event only fires in OTHER tabs.
    window.dispatchEvent(new StorageEvent("storage", { key: "cctv_alerts_last_viewed_at", newValue: now }));
  }, []);

  return (
    <div className="min-h-screen bg-black text-zinc-100 flex flex-col">
      <AppHeader active="alerts" />
      <div className="border-b border-zinc-900 bg-zinc-950 px-3 py-2">
        <div className="mono text-[10px] uppercase tracking-widest text-cyan-400">Motion Alerts</div>
        <div className="mono text-[9px] text-zinc-500 mt-0.5">Real-time detection feed · refreshes every 15s</div>
      </div>
      {/* Full-width alert feed */}
      <div className="flex-1 min-h-0 flex flex-col pb-16 md:pb-0" data-testid="mobile-alerts-feed">
        <div className="flex-1 min-h-0">
          <MotionAlerts fullscreen />
        </div>
      </div>
      <MobileBottomNav active="alerts" />
    </div>
  );
}
